import './DataInlineEditor.sass';

import Vue, { VNodeChildren } from 'vue';
import mixins from '@/utils/mixins';
import { VNode } from 'vue/types/umd';
import { keyCodes } from '@/utils/helpers';
import Returnable from '@/mixins/returnable';

export default mixins(Returnable).extend({
  name: 'v-edit-dialog',

  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    eager: Boolean,
    persistent: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  data() {
    return {
      isActive: false
    };
  },

  watch: {
    isActive(val) {
      if (val) {
        this.$emit('open');
        setTimeout(this.focus, 50); // Give DOM time to paint
      } else {
        this.$emit('close');
      }
    }
  },

  methods: {
    cancel() {
      this.isActive = false;
      this.$emit('cancel');
    },
    focus() {
      const input = (this.$refs.content as Element).querySelector('input');
      input && input.focus();
    },
    genButton(fn: Function, text: VNodeChildren, props?: object): VNode {
      return this.$createElement(
        'v-btn',
        {
          props: {
            ...props,
            color: 'primary',
            light: true
          },
          on: { click: fn }
        },
        text
      );
    },
    genActions(): VNode {
      return this.$createElement(
        'div',
        {
          class: 'data-inline__actions',
          style: {
            'box-sizing': 'border-box',
            'max-height': '100%',
            display: 'flex',
            'flex-direction': 'row',
            'place-content': 'center flex-end',
            'align-items': 'center'
          }
        },
        [
          this.genButton(this.cancel, this.cancelText, { text: true }),
          this.genButton(
            () => {
              this.save(this.returnValue);
              this.$emit('save', this.returnValue);
            },
            this.saveText,
            { text: false }
          )
        ]
      );
    },
    genContent(): VNode {
      return this.$createElement(
        'div',
        {
          staticClass: 'data-inline__content',
          on: {
            keydown: (e: KeyboardEvent) => {
              const input = (this.$refs.content as Element).querySelector(
                'input'
              );
              e.keyCode === keyCodes.esc && this.cancel();
              if (e.keyCode === keyCodes.enter && input) {
                this.save(input.value);
                this.$emit('save');
              }
            }
          },
          ref: 'content'
        },
        [this.$slots.input]
      );
    }
  },

  render(h): VNode {
    return h(
      'v-menu',
      {
        staticClass: 'data-inline',
        // class: this.themeClasses,
        props: {
          contentClass: 'data-inline__menu-content',
          transition: this.transition,
          origin: 'top right',
          right: true,
          value: this.isActive,
          closeOnClick: !this.persistent,
          closeOnContentClick: false,
          eager: this.eager
          // light: this.light,
          // dark: this.dark,
        },
        on: {
          input: (val: boolean) => (this.isActive = val)
        },
        scopedSlots: {
          activator: ({ on }) => {
            return h(
              'div',
              {
                staticClass: 'data-inline__activator',

                on: {
                  dblclick: (val: boolean) => (this.isActive = val)
                }
              },
              [
                h(
                  'span',
                  {
                    staticClass: 'data-inline__activator__content'
                  },
                  this.$slots.default
                )
              ]
            );
          }
        }
      },
      [
        this.$createElement(
          'div',
          {
            staticClass: 'editor-card'
          },
          [this.genContent(), this.large ? this.genActions() : null]
        )
      ]
    );
  }
});
